<ng-container *ngFor="let translation of this.myTranslations?.items; let i = index">
    <table class="translation-table">
        <thead>
            <tr>
                <th colspan="2">{{ translation[this.languages[0].code]?.fieldName }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let lnT of this.languages">
                <td class="text-center" style="width: 1px;">
                    <span class="translation-language-indicator">{{ lnT.code }}</span>
                </td>
                <td>
                    <textarea rows="2" class="form-control input-local"
                        [(ngModel)]="translation[lnT.code].localName"
                        (blur)="saveTranslation(translation[lnT.code])">
                    </textarea>
                </td>
            </tr>
        </tbody>
    </table>
</ng-container>